<template>
<div>
  <el-row>
    <el-col :span="17">
      <!-- 面包屑导航区域-->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }">Homepage</el-breadcrumb-item>
        <el-breadcrumb-item>Quality</el-breadcrumb-item>
        <el-breadcrumb-item>QA Test Request</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
  </el-row>
  <el-card>
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-row>
        <el-col :span="12">
          <el-form-item label="Project Number:" label-width="200px">
            <el-input v-model="formInline.project" placeholder="Project Number" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Brand:" label-width="200px">
            <el-input v-model="formInline.brand" placeholder="Brand" clearable></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="Business Partner:" label-width="200px">
            <el-input v-model="formInline.bp" placeholder="Business Partner" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="Description:" label-width="200px">
            <el-input v-model="formInline.description" placeholder="Description" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item style="margin-left: 4rem">
            <p>Active/Inactive:</p>
            <el-switch
              @change="oppcloChange"
              style="display: block"
              v-model="formInline.oppclo"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-value="1"
              inactive-value="2">
            </el-switch>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row style="text-align: center">
        <el-col :span="24">
        <el-form-item>
          <el-button type="primary" @click="onSubmit">Search</el-button>
        </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-table :data="qaProjectList" border stripe style="width: 100%">
      <!--          <el-table-column type="index" label="#"></el-table-column>-->
      <el-table-column
        prop="id"
        label="Id"
        width="50">
      </el-table-column>
      <el-table-column
        prop="sequenceNo"
        label="Project"         sortable
        width="100">
      </el-table-column>
      <el-table-column
        prop="projectLeader"
        label="Need Finish Report"
        width="100">
      </el-table-column>
      <el-table-column
        prop="brand"
        label="Brand"         sortable
        width="100">
      </el-table-column>
      <el-table-column
        prop="bp"
        label="Business Partner"         sortable
        width="180">
      </el-table-column>
      <el-table-column
        prop="description"
        label="Project Description" sortable
        width="180">
      </el-table-column>
      <el-table-column
        prop="salesRep"
        label="Sales Rep"
        width="100">
      </el-table-column>
      <el-table-column
        prop="planning"
        label="Planning"
        width="100">
      </el-table-column>
<!--      <el-table-column-->
<!--        prop="updateBy"-->
<!--        label="updateBy"-->
<!--        width="100">-->
<!--      </el-table-column>-->
      <el-table-column label="Operation" width="">
        <template slot-scope="index">
          <!-- <el-button type="info" plain size="mini" @click="view(props.row.id)">View</el-button> -->
          <!--            <el-button type="info" plain size="mini" @click="getOutputCalendar(index)">Output Calendar</el-button>-->
          <el-button type="info" plain size="mini" @click="getRequestList(index)">
            QA Test Request <i class="el-icon-notebook-2"></i>({{index.row.updateBy}})
            <!--              <span style="color: green">28</span> <span style="color: orangered">2</span>-->
          </el-button>
<!--          <el-button type="info" plain size="mini" @click="getMachineList(index)">-->
<!--            <i class="el-icon-folder-checked"></i> QA Plan Checking-->
<!--          </el-button>-->
          <!--              <el-button type="info" plain size="mini" @click="getPermissions(index)">Followers</el-button>-->
          <!--            <el-button type="info" plain size="mini" @click="edit(index)">Edit</el-button>-->
          <!--          <el-button type="info" plain size="mini" @click="del(props.row.code)">Delete</el-button>-->
        </template>
      </el-table-column>
    </el-table>
    <br>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage4"
      :page-sizes="[100, 200, 300, 400]"
      :page-size="100"
      layout="total, sizes, prev, pager, next, jumper"
      :total=total>
    </el-pagination>
  </el-card>
</div>
</template>

<script>
export default {
  data () {
    return {
      total: 0,
      qaProjectList: [],
      actualQuantity: '',
      orderQty: [],
      orderQtySum: 0,
      description: [],
      colorInspection: [],
      artworkInspection: [],
      controlElementsChecking: [],
      packagingControl: [],
      checked: true,
      item: [],
      po: [],
      supplier: [],
      brand: [],
      multipleSelection: [],
      dialogVisible: false,
      value: '',
      options: [{
        value: 'Accept'
      }, {
        value: 'Reject'
      }, {
        value: 'Pending'
      }, {
        value: 'Conditional Accept'
      }],
      qcScheduleList: [],
      formInline: {
        oppclo: '1',
        QCReportStatus: '',
        item: '',
        po: '',
        page: 1,
        size: 100,
        rows: 100,
        project: '',
        brand: '',
        supplier: '',
        bp: ''
      }
    }
  },
  name: 'QARequest',
  created () {
    this.getQAProjectList()
  },
  methods: {
    async oppcloChange () {
      const { data: res } = await this.$http.get('/QAProject/getQAProjectList', { params: this.formInline })
      this.qaProjectList = res.records
      this.total = res.total
    },
    getRequestList (index) {
      console.log(index.row)
      this.$router.push(`/qaTestRequest?sequenceNo=${index.row.sequenceNo}&bp=${index.row.bp}&brand=${index.row.brand}&description=${index.row.description}`)
    },
    async onSubmit () {
      const { data: res } = await this.$http.get('/QAProject/getQAProjectList', { params: this.formInline })
      this.qaProjectList = res.records
      this.total = res.total
    },
    async handleSizeChange (val) {
      this.formInline.size = val
      const { data: res } = await this.$http.get('/QAProject/getQAProjectList', { params: this.formInline })
      this.qaProjectList = res.records
      this.total = res.total
    },
    async handleCurrentChange (val) {
      this.formInline.page = val
      const { data: res } = await this.$http.get('/QAProject/getQAProjectList', { params: this.formInline })
      this.qaProjectList = res.records
      this.total = res.total
    },
    async getQAProjectList () {
      const { data: res } = await this.$http.get('/QAProject/getQAProjectList', { params: this.formInline })
      this.qaProjectList = res.records
      this.total = res.total
    }
  }
}
</script>

<style lang="less" scoped="scoped">
  .table-body {
    width: 100%;
    border-right: 1px solid #999;
    border-bottom: 1px solid #999;
    td {
      table-layout: fixed;
      border-collapse: collapse;
      border-top: 1px solid #999;
      border-left: 1px solid #999;
      border-spacing: 0;
    }
  }
  .section-header {
    text-align: left;
    font-size: 15px;
    font-weight: bold;
    background-color: rgb(192,192,192);
  }
</style>
